import UserTypeForm from "components/UserType";

const USerType = () => {
  return <UserTypeForm />;
};

export default USerType;
